<template>
  <div class="listing-feed u-bottom-margin">
    <transition name="fade" mode="out-in">
      <div class="o-container" v-if="!hideTagList && initialFeedLoaded && tagsLoaded">
        <div class="mobile-toggle">
          <button class="mobile-toggle__button" :class="{ 'mobile-toggle__button--active' : showFilterAtMobile}" @click="toggleMobileFilter">
            <span class="sr-only">Open</span> Filters
          </button>
        </div>
        <div class="listing-feed__filter" :class="{'listing-feed__filter--show-at-mobile' : showFilterAtMobile}">
            <div class="listing-feed__filter-left">
                <select-filter v-if="tags.activityType.length" label="Activity Type"  :options="tags.activityType" v-model="filter.activityType" @hasChanged="updateRouterQueries" :icon="{viewBox:'0 0 12 16', width:26, height:24, url:'/dist/images/icons.svg#icon-arrow'}" />
                <select-filter v-if="tags.eventPlace.length" label="Online & in person" :icon="{viewBox:'0 0 12 16', width:26, height:24, url:'/dist/images/icons.svg#icon-arrow'}" :options="tags.eventPlace" v-model="filter.eventPlace" @hasChanged="updateRouterQueries" />
                <select-filter v-if="tags.localArea.length" label="Local area" :icon="{viewBox:'0 0 12 16', width:26, height:24, url:'/dist/images/icons.svg#icon-arrow'}" :options="tags.localArea" v-model="filter.localArea" @hasChanged="updateRouterQueries" />
            </div>
            <div class="listing-feed__filter-right">
                <select-filter v-if="tags.timePeriod.length" label="Filter by date" :options="tags.timePeriod" v-model="filter.timePeriod" @hasChanged="updateRouterQueries"  :icon="{viewBox:'0 0 12 16', width:26, height:24, url:'/dist/images/icons.svg#icon-calendar'}"/>
            </div>
        </div>
      </div>
    </transition>
    <div class="o-container o-container o-container--half-padding">
      <transition name="fade" mode="out-in">
        <div key="results" v-if="feedLoaded">
          <transition name="fade" mode="out-in">
            <div class="c-article-list" v-if="set[0].children.length">
              <event-feed-set :hide-tags="hideTags" :default-selected-tags="filter.acitivityType" v-for="(item, index) in set" :data="item.children" :key="`set-${index}`" />
              <div class="listing-feed__message" v-if="isLoadingMoreResults">
                <span class="sr-only">Loading</span>
                <loader />
              </div>
              <app-paging @loadMoreClicked="fetchData" :current-page="currentPage" :total-pages="totalPages" :current-visible-items-count="currentVisibleArticleItemCount" :total-items-count="totalEventItemCount" />
            </div>
            <p v-else class="listing-feed__message">
              Sorry, no results. Please try adjusting the filters.
            </p>
          </transition>
        </div>
        <div v-else key="loading" class="listing-feed__message">
          <span class="sr-only">Loading</span>
          <loader />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import EventFeedSet from './components/event-feed-set.vue'
import SelectFilter from '../common/listing/select-filter.vue'
import AppPaging from '../common/listing/paging.vue'
import VueRouter from 'vue-router'
import Loader from '../common/loader.vue'
import { getEventsByParentId, getEventTagsByParentId } from '../../api/content/api.js'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: []
})

export default {
    router,
    placeholderId: 'event-listing-placeholder',
    props: {
        hideTags: {
            type: String,
            required: false,
            default: ''
        },
        distIconPath: {
            type: String,
            required: false,
            default: ''
        },
        parentId: {
            type: String,
            required: false,
            default: ''
        }
    },
    components: {
        EventFeedSet,
        Loader,
        SelectFilter,
        AppPaging
    },
    data() {
        return {
            set: [],
            currentPage: 0,
            showFilterAtMobile: false,
            tagsLoaded: false,
            totalPages: 0,
            feedLoaded: false,
            initialFeedLoaded: false,
            totalEventItemCount: 0,
            isLoadingMoreResults: false,
            tags: {
                localArea: [],
                activityType: [],
                eventPlace: [
                    {
                        Id: 1,
                        Name: 'Online'
                    },
                    {
                        Id: 2,
                        Name: 'In Person'
                    }
                ],
                timePeriod: [
                    {
                        Id: 1,
                        Name: 'This week'
                    },
                    {
                        Id: 2,
                        Name: 'Next week'
                    },
                    {
                        Id: 3,
                        Name: 'This month'
                    },
                    {
                        Id: 4,
                        Name: 'Next month'
                    }
                ],
            },
            filter: {
                activityType: '',
                eventPlace: '',
                localArea: '',
                timePeriod: '',
            }
        }
    },
    computed: {
        listingApiQueries() {
            const params = {}
            params.sortAscending = true
            if (this.parentId) { params.parentId = this.parentId }
            if (this.currentPage) { params.pageNumber = this.currentPage }
            // loop through filters
            for (const [key, value] of Object.entries(this.filter)) {
                if (value && value.length) {
                    params[key] = value.toString('')
                }
            }
            return params
        },
        currentVisibleArticleItemCount() {
            return this.set.reduce((count, current) => count + current.children.length, 0)
        },
        hideTagList() {
            const hide = this.hideTags === 'True'
            if(hide) {
                return true
            }
            return false
        },
        routerQueries() {
            const queries = {}
            // loop over filters
            for (const [key, value] of Object.entries(this.filter)) {
                if (value && value.length) {
                    // map to filter name and update corresponding router query
                    queries[key] = value.toString('')
                }
            }
            return queries
        },
    },
    methods: {
        fetchData(loadMore) {
            if(loadMore) {
                this.currentPage++
                this.isLoadingMoreResults = true
                getEventsByParentId(this.listingApiQueries).then((response) => {
                    this.set.push({ children: response.data.data, currentPage: this.currentPage})
                    this.isLoadingMoreResults = false
                })
            }
            else {
                this.currentPage = 0
                this.feedLoaded = false
                getEventsByParentId(this.listingApiQueries).then((response) => {
                    this.set = [{children: response.data.data, currentPage: this.currentPage}]
                    this.totalPages = response.data.totalPages
                    this.totalEventItemCount = response.data.TotalItemCount
                    this.feedLoaded = true
                    this.initialFeedLoaded = true
                })
            }
        },
        fetchTags() {
            getEventTagsByParentId({ parentId: this.parentId}).then(([{data: activityType}, {data: locationArea}])=> {
                this.tags.activityType = activityType.data
                this.tags.localArea = locationArea.data
                this.tagsLoaded = true
            })
        },
        updateRouterQueries() {
            router.push({ query: this.routerQueries})
        },
        toggleMobileFilter() {
            this.showFilterAtMobile = !this.showFilterAtMobile
        },
        getFilterValuesFromQueryString() {
            for (const [key] of Object.entries(this.filter)) {
                if(this.$route.query[key] != null && this.$route.query[key] != '') {
                    this.filter[key] = this.$route.query[key]
                }
                else {
                    this.filter[key] = ''
                }
            }
        }
    },
    mounted() {
        this.getFilterValuesFromQueryString()
        this.fetchData()
        if(!this.hideTagList) {
            this.fetchTags()
        }
    },
    watch: {
        '$route.query'(to, from) {
            if(to !== from) {
                this.getFilterValuesFromQueryString()
                this.fetchData()
            }
        }
    }
}
</script>